module.exports = __webpack_public_path__ + "web/img/mkv.8d929590.png";